module.exports = __webpack_public_path__ + "38a1a09d83c45830331ca99e00bf3ff1.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/stones-throw-hat.jpg
 ** module id = 458
 ** module chunks = 0
 **/